import React, { useState, useContext, useEffect } from 'react';
import { withStyles } from "@material-ui/core/styles";
import CloseButtonDialog from './CloseButtonDialog';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Menu from '@material-ui/core/Menu';
import Badge from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import Icon from '@material-ui/core/Icon';
import PropTypes from 'prop-types';
import TablePagination from '@material-ui/core/TablePagination';
import Tooltip from '@material-ui/core/Tooltip';
import PrintIcon from "@material-ui/icons/Print";
import Code from "@material-ui/icons/Code";
import axios from 'axios';
import _ from 'underscore';
import { TipoDoc } from 'App/Helpers/Iconos';
import { DigitoVerificador, separadorMiles } from "App/Helpers/Genericos";
import RemoteTable from 'App/components/RemoteTable';
import { LayoutContext } from 'App/Layout/store';

import moment from 'moment';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
});

const columns = [
    { name: "ID", key: "id_dte", options: { display: false } },
    { name: "RUT", key: "rut", options: { customBodyRender: (value, tableMeta, updateValue) => { return value ? (value.toLocaleString() + "-" + DigitoVerificador(value)) : "" } } },
    { name: "Razon Social", key: "razon_social" },
    { name: "Tipo", key: "tipo_doc", options: { customBodyRender: (value, tableMeta, updateValue) => { return TipoDoc(value) } } },
    { name: "Folio", key: "folio" },
    { name: "Emision", key: "fecha_emision", options: { sortDirection: 'desc', customBodyRender: (value, tableMeta, updateValue) => { return moment(value).format("L") } } },
    { name: "$ Neto", key: "neto", options: { customBodyRender: (value, tableMeta, updateValue) => { return (value || 0).toLocaleString() } } },
    { name: "$ Exento", key: "exento", options: { customBodyRender: (value, tableMeta, updateValue) => { return (value || 0).toLocaleString() } } },
    { name: "$ IVA", key: "IVA", options: { customBodyRender: (value, tableMeta, updateValue) => { return (value || 0).toLocaleString() } } },
    { name: "$ Total", key: "total", options: { customBodyRender: (value, tableMeta, updateValue) => { return (value || 0).toLocaleString() } } }
]

const defaultToolbarSelectStyles = {
    iconButton: {
        marginRight: "24px"
    }
};


function ModalDTEs(props) {

    const layoutContext = useContext(LayoutContext);

    const [filasTabla, setFilasTabla] = useState({});
    const [cargando, setCargando] = useState(-1);

    function actualizaTabla(d) {
        if (!cargando || cargando == -1) {
            setCargando(true)
            axios.post("/api/libro/" + props.Libro + "/dte", d)
                .then(da => { setFilasTabla(da); setCargando(false) }).catch(e => console.error(e))
        }
    }

    var content =
        props.abrir ?
            <Grid container>
                <RemoteTable columns={columns} url={"/api/libro/" + props.Libro + "/dte"} query={actualizaTabla} contenido={filasTabla} data={[]} method="post" title={"Documentos"} CustomToolBar={ParentCustomToolbarSelect(props, layoutContext, actualizaTabla)} CustomFooter={CustomFooter} download></RemoteTable>
            </Grid>
            : null;

    const footer = (
        <DialogActions>
            <Button onClick={() => props.cerrar()} color="secondary" autoFocus>
                Cerrar
            </Button>
        </DialogActions>
    );

    return (
        <div>
            <CloseButtonDialog open={props.abrir} onClose={() => props.cerrar()} closeButton title={"Documentos en el Libro #" + props.Libro} content={content} footer={footer} size="md" />
        </div>
    );
}

export default withStyles(styles)(ModalDTEs);

function ParentCustomToolbarSelect(parentProps, layoutContext, actualizaTabla) {
    function CustomToolbarSelect(props) {
        const quitarDelLibro = () => {
            var conf = window.confirm("¿Está seguro de querer eliminar los Documentos seleccionados de este Libro?");
            if (conf) {
                axios.post(`/api/libro/${parentProps.Libro}/eliminardte`, props.selectedRows.map(e => { return { IdDte: e.data[0] } }))
                    .then(o => { alert("DTEs eliminados exitosamente"); actualizaTabla({}); })
                    .catch(e => /*alert(e.response.data.Mensaje)*/{})
                    .finally(() => layoutContext.dispatch({ type: "toggleLibro", libro: layoutContext.state.libro === null ? false : null }))
            }
        };
        return (
            <div className={"custom-toolbar-select"}>
                {parentProps.estado == "Borrador" &&
                    <Tooltip title="Quitar del Libro">
                        <IconButton className={parentProps.classes.iconButton} onClick={quitarDelLibro}>
                            <Icon>remove</Icon>
                        </IconButton>
                    </Tooltip>}
            </div>
        );

    }
    var CustomToolBar = withStyles(defaultToolbarSelectStyles, {
        name: "CustomToolbarSelect"
    })(CustomToolbarSelect);
    return CustomToolBar;
}

function CustomFooter(count, page, rowsPerPage, changeRowsPerPage, changePage) {
    return <TablePagination
        rowsPerPageOptions={[25, 50, 100]}
        component="div"
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        labelRowsPerPage="Filas por página"
        backIconButtonProps={{
            'aria-label': 'Página anterior',
        }}
        nextIconButtonProps={{
            'aria-label': 'Página siguiente',
        }}
        onChangePage={(evt, page) => { changePage(page) }}
        onChangeRowsPerPage={(evt) => { changeRowsPerPage(evt.target.value) }}
    />
}